"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var isDOMElement = require("./isDOMElement.js");
/**
 * Find one or more DOM elements.
 *
 * @param {string|Node} element
 * @returns {Node[]|null}
 */ function findAllDOMElements(element) {
    if (typeof element === 'string') {
        var elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if ((typeof element === "undefined" ? "undefined" : _type_of(element)) === 'object' && isDOMElement(element)) {
        return [
            element
        ];
    }
    return null;
}
module.exports = findAllDOMElements;
